module.exports = __webpack_public_path__ + "static/media/bamazon.ef270347.gif";